"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escrowComputeServiceAgreementTemplate = void 0;
exports.escrowComputeServiceAgreementTemplate = {
    contractName: 'EscrowComputeExecutionTemplate',
    events: [
        {
            name: 'AgreementActorAdded',
            actorType: 'provider',
            handler: {
                moduleName: '',
                functionName: 'fulfillLockRewardCondition',
                version: '0.1'
            }
        }
    ],
    fulfillmentOrder: [
        'lockReward.fulfill',
        'computeExecution.fulfill',
        'escrowReward.fulfill'
    ],
    conditionDependency: {
        lockReward: [],
        computeExecution: [],
        escrowReward: ['lockReward', 'computeExecution']
    },
    conditions: [
        {
            name: 'lockReward',
            timelock: 0,
            timeout: 0,
            contractName: 'LockRewardCondition',
            functionName: 'fulfill',
            parameters: [
                {
                    name: '_rewardAddress',
                    type: 'address',
                    value: ''
                },
                {
                    name: '_amount',
                    type: 'uint256',
                    value: ''
                }
            ],
            events: [
                {
                    name: 'Fulfilled',
                    actorType: 'provider',
                    handler: {
                        moduleName: 'lockRewardExecutionCondition',
                        functionName: 'fulfillComputeExecutionCondition',
                        version: '0.1'
                    }
                }
            ]
        },
        {
            name: 'computeExecution',
            timelock: 0,
            timeout: 0,
            contractName: 'ComputeExecutionCondition',
            functionName: 'fulfill',
            parameters: [
                {
                    name: '_documentId',
                    type: 'bytes32',
                    value: ''
                },
                {
                    name: '_grantee',
                    type: 'address',
                    value: ''
                }
            ],
            events: [
                {
                    name: 'Fulfilled',
                    actorType: 'provider',
                    handler: {
                        moduleName: 'accessSecretStore',
                        functionName: 'fulfillEscrowRewardCondition',
                        version: '0.1'
                    }
                },
                {
                    name: 'TimedOut',
                    actorType: 'consumer',
                    handler: {
                        moduleName: 'accessSecretStore',
                        functionName: 'refundReward',
                        version: '0.1'
                    }
                }
            ]
        },
        {
            name: 'escrowReward',
            timelock: 0,
            timeout: 0,
            contractName: 'EscrowReward',
            functionName: 'fulfill',
            parameters: [
                {
                    name: '_amount',
                    type: 'uint256',
                    value: ''
                },
                {
                    name: '_receiver',
                    type: 'address',
                    value: ''
                },
                {
                    name: '_sender',
                    type: 'address',
                    value: ''
                },
                {
                    name: '_lockCondition',
                    type: 'bytes32',
                    value: ''
                },
                {
                    name: '_releaseCondition',
                    type: 'bytes32',
                    value: ''
                }
            ],
            events: [
                {
                    name: 'Fulfilled',
                    actorType: 'provider',
                    handler: {
                        moduleName: 'escrowRewardCondition',
                        functionName: 'verifyRewardTokens',
                        version: '0.1'
                    }
                }
            ]
        }
    ]
};
//# sourceMappingURL=EscrowCompute.serviceAgreementTemplate.js.map